<ion-menu *ngIf="isOpen"
[side]="'start'"
[menuId]="menuId"
[contentId]="contentId"
class="brand-selection-menu"
[maxEdgeStart]="100"
type="overlay"
(ionDidClose)="isOpen = false"
>
  <ion-content class="landscape-menu-content">
    <div class="flex flex-col gap-3 bg-white p-3 lg:p-4">
      <b class="text-base">Espacio de trabajo</b>

      <div *ngFor="let theme of themes"
      (click)="onBrandClick(theme.key)"
      class="brand-card rounded-default border-1 p-2 grid grid-cols-[auto_1fr_auto] gap-3 items-center cursor-pointer hover:bg-gray-100"
      [ngClass]="{
        'border-[#5458EA]': activeThemeKey === theme.key,
        'border-transparent': activeThemeKey !== theme.key
      }"
      >
        <div class="flex justify-center items-center w-8 h-8 rounded-default border-1 border-solid border-[#b6b6b6] p-[2px]">
          <img [src]="theme.isotipo_app || theme.app_main_isotipo || theme.logo_app" class="w-full h-full object-contain rounded-default bg-white border-[#9696963d] border-solid border-1" />
        </div>
        <div class="flex flex-col justify-center min-w-0">
          <p class="font-semibold text-sm leading-4">{{theme.titulo_login_app}}</p>
          <p class="text-xs text-gray-600">{{extractSubdomain(theme.serviceBase)}}</p>
        </div>
        <!-- Quitar este espacio del dispositivo. En desktop aparece al pasar el
             mouse por la tarjeta; en táctil siempre visible (no hay hover). -->
        <button type="button"
          class="brand-remove-btn flex justify-center items-center bg-transparent border-none p-0 w-6 h-6"
          aria-label="Quitar espacio de trabajo"
          (click)="onRemoveBrandClick(theme, $event)"
        >
          <mat-icon class="mdi mdi-close text-lg leading-[16px] w-4 h-4 max-w-[16px]"></mat-icon>
        </button>
      </div>

      <button (click)="onAddWorkspaceClick()" class="flex gap-1 items-center text-xxs text-primary bg-transparent border-none mt-1">
        <mat-icon class="mdi mdi-plus text-xs leading-3 max-w-[20px]"></mat-icon>
        Agregar otro espacio de trabajo
      </button>

    </div>
  </ion-content>
</ion-menu>
